<script setup lang="ts">
import { ref } from 'vue'

const certifiedSealAssemblerPoints = ref([
  'Qualified as an Ashcroft Diaphragm Seal Assembler',
  'Individuals are certified by Ashcroft to assemble, service and test Ashcroft Diaphragm Seals.'
])

const customerBenefits = ref([
  'As a Certified Seal Assembler for Ashcroft the lead time is shortened considerably for delivery if we have the parts in stock.  In most cases 1-3 days dependent upon quantity.',
  'Daughtridge Sales is able to determine and propose more complex assemblies based upon our experience and expertise in this realm.',
  'We can also cross from other brands to Ashcroft to enable shorter lead times in general on diaphragm seal assemblies.'
])
</script>

<template>
  <div>
    <div class="flex mt-4 text-3xl text-primary">
      <fa-icon
        icon="fa-light fa-lightbulb-on"
        class="text-yellow-500 text-4xl mr-2"
      />
      Did you know that Daughtridge Sales is a Certified Ashcroft Seal Assembler?
    </div>
    <div class="ml-4 mt-4">
      <article
        v-for="(i, idx) in certifiedSealAssemblerPoints"
        :key="`sealAssemblerPoint-${idx}`"
        class="flex align-items-start mb-2"
      >
        <fa-icon
          icon="fa-check-circle"
          class="text-green-500 mr-2"
        />
        <div class="text-lg text-wrap">
          {{ i }}
        </div>
      </article>
    </div>

    <div class="flex mt-4 text-3xl text-primary">
      <fa-icon
        icon="fa-shipping-fast"
        class="mr-2"
      />
      Solutions for you and your customers... faster
    </div>
    <div class="ml-4 mt-4">
      <article
        v-for="(i, idx) in customerBenefits"
        :key="`sealAssemblerPoint-${idx}`"
        class="flex align-items-start mb-2"
      >
        <fa-icon
          icon="fa-check-circle"
          class="text-green-500 mr-2"
        />
        <div class="text-lg text-wrap">
          {{ i }}
        </div>
      </article>
    </div>
  </div>
</template>
